import React from "react";
import { Container, Grid } from "@mui/material";

import WelcomeCard from "../CMS/WelcomeCard";
import BlankCard from "../../Common/Card/BlankCard";
import BreadcrumbBuilder from "./BreadcrumbBuilder";

function Dashboard() {
    return (
        <React.Fragment>
            <Container className="content">
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <BreadcrumbBuilder />
                    </Grid>

                    <Grid item xs={12}>
                        <WelcomeCard appCode={"C-LRS"} />
                    </Grid>

                    <Grid item xs={6} sm={6} md={6}>
                        <BlankCard />
                    </Grid>

                    <Grid item xs={6} sm={6} md={6}>
                        <BlankCard />
                    </Grid>
                </Grid>
            </Container>
        </React.Fragment>
    );
}

export default Dashboard;
